var _path, _path2, _g, _g2, _g3, _g4, _g5, _g6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneyBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9965 16.0215H40.0059L42.671 10.9106C42.7376 10.7941 42.7781 10.6645 42.7899 10.5307C42.8016 10.397 42.7842 10.2623 42.7389 10.136C42.6936 10.0096 42.6215 9.89453 42.5274 9.79871C42.4334 9.70289 42.3197 9.62858 42.1943 9.58089L38.4717 8.16008L38.9781 7.14442C39.0489 7.00278 39.0823 6.84541 39.0752 6.68724C39.0681 6.52906 39.0207 6.37533 38.9374 6.24063C38.8542 6.10593 38.738 5.99473 38.5997 5.91758C38.4614 5.84043 38.3057 5.79989 38.1474 5.7998H28.855C28.6966 5.79973 28.5408 5.84016 28.4024 5.91724C28.264 5.99433 28.1476 6.10551 28.0643 6.24024C27.9809 6.37496 27.9334 6.52875 27.9263 6.68701C27.9191 6.84526 27.9525 7.00271 28.0233 7.14442L28.5307 8.16008L24.8072 9.57718C24.6813 9.62487 24.5672 9.69935 24.4729 9.79549C24.3786 9.89162 24.3063 10.0071 24.2611 10.1339C24.2158 10.2608 24.1987 10.3959 24.2108 10.53C24.223 10.6641 24.2641 10.794 24.3314 10.9106L26.9965 16.0215Z",
    fill: "url(#paint0_linear_1429_5214)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0189 15.0908H25.9867C25.9867 15.0908 14.1758 32.7421 14.1758 43.6044C14.1758 49.6887 16.6861 59.8979 33.5028 59.8979C50.3195 59.8979 52.8299 49.6887 52.8299 43.6044C52.8299 32.7421 41.0189 15.0908 41.0189 15.0908Z",
    fill: "url(#paint1_linear_1429_5214)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bi_1429_5214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.6982 18.9355H23.3069C23.3069 18.9355 7.28516 37.8703 7.28516 49.5225C7.28516 56.0492 10.6905 67.0008 33.5025 67.0008C56.3146 67.0008 59.7199 56.0492 59.7199 49.5225C59.7199 37.8703 43.6982 18.9355 43.6982 18.9355Z",
    fill: "#F1F1F1",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6982 18.9355H23.3069C23.3069 18.9355 7.28516 37.8703 7.28516 49.5225C7.28516 56.0492 10.6905 67.0008 33.5025 67.0008C56.3146 67.0008 59.7199 56.0492 59.7199 49.5225C59.7199 37.8703 43.6982 18.9355 43.6982 18.9355Z",
    fill: "url(#paint2_linear_1429_5214)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5876 19.5355H43.4175C43.5335 19.6754 43.7037 19.8823 43.9205 20.1497C44.3557 20.6866 44.9782 21.4676 45.7256 22.4415C47.2209 24.3899 49.2137 27.1074 51.2053 30.1854C53.1981 33.2652 55.1827 36.695 56.6674 40.0692C58.1563 43.4531 59.1199 46.7316 59.1199 49.5225C59.1199 52.6868 58.2957 56.8736 54.7503 60.2762C51.2003 63.6833 44.822 66.4008 33.5025 66.4008C22.1831 66.4008 15.8048 63.6833 12.2548 60.2762C8.70936 56.8736 7.88516 52.6868 7.88516 49.5225C7.88516 46.7316 8.8488 43.4531 10.3377 40.0692C11.8224 36.695 13.807 33.2652 15.7998 30.1854C17.7914 27.1074 19.7842 24.3899 21.2795 22.4415C22.0269 21.4676 22.6494 20.6866 23.0846 20.1497C23.3013 19.8823 23.4716 19.6754 23.5876 19.5355Z",
    stroke: "url(#paint3_linear_1429_5214)",
    strokeOpacity: 0.1,
    strokeWidth: 1.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bi_1429_5214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3039 16.0217H43.6952L47.8725 8.01087C47.9769 7.82818 48.0405 7.62504 48.0589 7.41542C48.0773 7.2058 48.0501 6.99469 47.979 6.79661C47.908 6.59853 47.795 6.41819 47.6476 6.268C47.5002 6.11781 47.322 6.00133 47.1253 5.92659L41.2905 3.69957L42.0843 2.10759C42.1952 1.88558 42.2476 1.63891 42.2364 1.39099C42.2253 1.14306 42.1509 0.902098 42.0205 0.690966C41.8901 0.479833 41.7078 0.305534 41.4911 0.184606C41.2744 0.0636778 41.0304 0.000132657 40.7822 1.58253e-07H26.217C25.9687 -0.000115575 25.7244 0.0632483 25.5075 0.184074C25.2906 0.304899 25.1082 0.479174 24.9776 0.690347C24.8469 0.901519 24.7725 1.14258 24.7613 1.39062C24.75 1.63867 24.8024 1.88547 24.9134 2.10759L25.7086 3.69957L19.8724 5.92076C19.675 5.99551 19.4962 6.11227 19.3484 6.26295C19.2006 6.41363 19.0873 6.59464 19.0163 6.79343C18.9454 6.99223 18.9185 7.20407 18.9376 7.41428C18.9566 7.62449 19.0211 7.82805 19.1266 8.01087L23.3039 16.0217Z",
    fill: "#F1F1F1",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3039 16.0217H43.6952L47.8725 8.01087C47.9769 7.82818 48.0405 7.62504 48.0589 7.41542C48.0773 7.2058 48.0501 6.99469 47.979 6.79661C47.908 6.59853 47.795 6.41819 47.6476 6.268C47.5002 6.11781 47.322 6.00133 47.1253 5.92659L41.2905 3.69957L42.0843 2.10759C42.1952 1.88558 42.2476 1.63891 42.2364 1.39099C42.2253 1.14306 42.1509 0.902098 42.0205 0.690966C41.8901 0.479833 41.7078 0.305534 41.4911 0.184606C41.2744 0.0636778 41.0304 0.000132657 40.7822 1.58253e-07H26.217C25.9687 -0.000115575 25.7244 0.0632483 25.5075 0.184074C25.2906 0.304899 25.1082 0.479174 24.9776 0.690347C24.8469 0.901519 24.7725 1.14258 24.7613 1.39062C24.75 1.63867 24.8024 1.88547 24.9134 2.10759L25.7086 3.69957L19.8724 5.92076C19.675 5.99551 19.4962 6.11227 19.3484 6.26295C19.2006 6.41363 19.0873 6.59464 19.0163 6.79343C18.9454 6.99223 18.9185 7.20407 18.9376 7.41428C18.9566 7.62449 19.0211 7.82805 19.1266 8.01087L23.3039 16.0217Z",
    fill: "url(#paint4_linear_1429_5214)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3459 7.72319L47.3516 7.71314C47.413 7.60571 47.4504 7.48625 47.4612 7.36298C47.472 7.23972 47.456 7.11557 47.4142 6.99909L47.979 6.79661L47.4142 6.99908C47.3725 6.8826 47.306 6.77655 47.2193 6.68823C47.1327 6.59991 47.0279 6.53141 46.9122 6.48746L46.9114 6.48714L41.0766 4.26012L40.4582 4.02412L40.7536 3.43183L41.5474 1.83985L41.5476 1.83939C41.6128 1.70883 41.6436 1.56377 41.6371 1.41798C41.6305 1.27219 41.5868 1.13049 41.5101 1.00633C41.4334 0.88217 41.3262 0.779672 41.1987 0.708559C41.0714 0.637499 40.928 0.600133 40.7822 0.6L47.3459 7.72319ZM47.3459 7.72319L47.3405 7.73345M47.3459 7.72319L47.3405 7.73345M47.3405 7.73345L43.3314 15.4217H23.6677L19.6586 7.73345L19.6527 7.72209L19.6463 7.71099C19.5843 7.60348 19.5463 7.48377 19.5351 7.36016C19.5239 7.23654 19.5397 7.11197 19.5815 6.99506C19.6232 6.87816 19.6898 6.77171 19.7767 6.6831C19.8636 6.59449 19.9688 6.52583 20.0848 6.48188L20.0858 6.48152L25.9221 4.26033L26.5417 4.02451L26.2454 3.43143L25.4501 1.83946L25.4501 1.83939C25.3848 1.70877 25.354 1.56364 25.3606 1.41777C25.3672 1.2719 25.411 1.13015 25.4878 1.00596C25.5647 0.881781 25.6719 0.779298 25.7995 0.708246C25.9271 0.637194 26.0707 0.599932 26.2167 0.6H26.217M47.3405 7.73345L26.217 0.6M26.217 0.6H40.782H26.217Z",
    stroke: "url(#paint5_linear_1429_5214)",
    strokeOpacity: 0.1,
    strokeWidth: 1.2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_1429_5214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.5189 43.3955C39.2089 42.1755 37.6443 41.2616 35.9382 40.7199L34.6142 40.2145V33.8742C36.4794 34.0298 38.3107 34.4643 40.047 35.1633L41.32 31.9764C39.1902 31.1029 36.9209 30.6189 34.62 30.5475V27.6738H32.2968V30.5956C30.4545 30.7044 28.6865 31.3606 27.2194 32.4803C26.6223 32.9486 26.142 33.5491 25.8165 34.2346C25.4909 34.92 25.329 35.6717 25.3434 36.4304C25.2987 37.8063 25.7658 39.1499 26.6543 40.2014C27.8128 41.3991 29.2441 42.2987 30.8258 42.8231L32.2823 43.362V49.877C31.0707 49.8439 29.867 49.6713 28.6949 49.3629C27.4899 49.077 26.3183 48.6655 25.1992 48.135V51.8084C27.4478 52.7248 29.8589 53.1757 32.2867 53.1338V56.8043H34.604V53.029C36.5468 52.9226 38.4088 52.2163 39.9334 51.0073C40.5297 50.4935 41.0046 49.8537 41.3237 49.1341C41.6429 48.4144 41.7983 47.633 41.7788 46.846C41.8151 45.5771 41.3643 44.3425 40.5189 43.3955ZM32.2968 39.3566C31.4687 39.0777 30.7067 38.6315 30.0582 38.0457C29.6432 37.5966 29.4214 37.0023 29.4406 36.3911C29.4346 36.0866 29.497 35.7847 29.623 35.5074C29.749 35.2302 29.9355 34.9847 30.1689 34.7889C30.7805 34.3071 31.5175 34.0109 32.2925 33.9354L32.2968 39.3566ZM34.6142 49.7372V44.182C35.4721 44.4526 36.2722 44.8803 36.9737 45.4434C37.2039 45.6537 37.386 45.9111 37.5077 46.1982C37.6293 46.4852 37.6876 46.7951 37.6787 47.1067C37.6806 48.5458 36.6591 49.4226 34.6142 49.7372Z",
    fill: "white",
    fillOpacity: 0.16
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_1429_5214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.696 16.0215H23.3047V18.9345H43.696V16.0215Z",
    fill: "url(#paint6_linear_1429_5214)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_1429_5214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.6327 9.54424L25.7095 3.69922L22.9727 4.74063L26.0314 10.8464C26.1159 11.019 26.2339 11.1732 26.3783 11.3C26.5228 11.4268 26.6909 11.5238 26.873 11.5853C27.0551 11.6469 27.2476 11.6717 27.4394 11.6585C27.6312 11.6453 27.8184 11.5943 27.9904 11.5084C28.1623 11.4224 28.3156 11.3033 28.4413 11.1579C28.567 11.0124 28.6626 10.8436 28.7227 10.661C28.7829 10.4784 28.8062 10.2857 28.7915 10.094C28.7768 9.90238 28.7243 9.71552 28.6371 9.54424H28.6327Z",
    fill: "url(#paint7_linear_1429_5214)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_1429_5214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.3682 9.54424L41.2914 3.69922L44.0282 4.74063L40.9695 10.8464C40.8849 11.019 40.767 11.1732 40.6226 11.3C40.4781 11.4268 40.31 11.5238 40.1279 11.5853C39.9458 11.6469 39.7533 11.6717 39.5615 11.6585C39.3697 11.6453 39.1825 11.5943 39.0105 11.5084C38.8386 11.4224 38.6853 11.3033 38.5596 11.1579C38.4339 11.0124 38.3383 10.8436 38.2781 10.661C38.218 10.4784 38.1946 10.2857 38.2093 10.094C38.2241 9.90238 38.2765 9.71552 38.3638 9.54424H38.3682Z",
    fill: "url(#paint8_linear_1429_5214)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bi_1429_5214",
    x: -16.7148,
    y: -5.06445,
    width: 100.435,
    height: 96.0654,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1429_5214"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1429_5214",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1429_5214"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bi_1429_5214",
    x: -5.06836,
    y: -24,
    width: 77.1328,
    height: 64.0215,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1429_5214"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1429_5214",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1429_5214"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_1429_5214",
    x: 25.1992,
    y: 27.6738,
    width: 16.582,
    height: 37.1309,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1429_5214"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_1429_5214",
    x: 23.3047,
    y: 16.0215,
    width: 20.3916,
    height: 10.9131,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1429_5214"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_1429_5214",
    x: 22.9727,
    y: 3.69922,
    width: 5.82324,
    height: 15.9629,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1429_5214"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_1429_5214",
    x: 38.2051,
    y: 3.69922,
    width: 5.82324,
    height: 15.9629,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1429_5214"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1429_5214",
    x1: 24.9815,
    y1: 7.84414,
    x2: 44.3948,
    y2: 12.7469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AE6CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C3AE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1429_5214",
    x1: 15.7864,
    y1: 24.0522,
    x2: 58.1275,
    y2: 29.1254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AE6CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C3AE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1429_5214",
    x1: 9.46994,
    y1: 28.5486,
    x2: 66.4233,
    y2: 37.1779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66FECB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8940FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1429_5214",
    x1: 8.92374,
    y1: 21.1203,
    x2: 59.7199,
    y2: 21.1203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69CFB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1429_5214",
    x1: 20.1455,
    y1: 3.20435,
    x2: 50.5746,
    y2: 10.8891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66FECB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8940FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1429_5214",
    x1: 19.842,
    y1: 0.728261,
    x2: 48.0645,
    y2: 0.728261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69CFB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1429_5214",
    x1: 24.1543,
    y1: 16.6041,
    x2: 35.8019,
    y2: 27.9281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AE6CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C3AE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1429_5214",
    x1: 23.2153,
    y1: 5.29177,
    x2: 29.6194,
    y2: 5.94223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AE6CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C3AE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1429_5214",
    x1: 38.4477,
    y1: 5.29177,
    x2: 44.8518,
    y2: 5.94223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AE6CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C3AE7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyBag);
export default __webpack_public_path__ + "static/media/money-bag.5f5bca55662d515479598ed68008f871.svg";
export { ForwardRef as ReactComponent };